var map = {
	"./Co-packing.png": 2909,
	"./Lagerlogistik.png": 5658,
	"./Produktionsarbeiten.png": 1797,
	"./Produktveredelung.png": 3545,
	"./aktionen.png": 8770,
	"./chargenverfolgung.png": 8584,
	"./etikettierung.png": 713,
	"./kodierung.png": 6223,
	"./online-shop_fulfillment.png": 1984,
	"./qualitatskontrolle.png": 6835,
	"./shrinking.png": 60,
	"./sleeving.png": 972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2246;